import { Component } from '@angular/core';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    standalone: false
})
export class LayoutComponent {

  isCondensed = false;

  /**
   * On mobile toggle button clicked
   */
  onToggleMobileMenu(): void {
    this.isCondensed = !this.isCondensed;
  }

  /**
   * Close mobile menu when backdrop is clicked
   */
  closeMobileMenu(): void {
    if (document.body.classList.contains('sidebar-enable')) {
      document.body.classList.remove('sidebar-enable');
      this.isCondensed = false;
    }
  }

}

